import React from 'react'
import { css } from 'emotion'
import { metrotownLocationButton, downtownLocationButton } from 'images'
import { MEDIA_QUERY } from 'styles'

const LocationSelectNameView = ({ locationId }) => (
  <img
    className={styles.location}
    src={
      locationId === 'mihbDMkGvzSmBz09dE7Z'
        ? metrotownLocationButton
        : downtownLocationButton
    }
    alt="Location Button"
  />
)

const styles = {
  location: css({
    cursor: 'pointer',
    marginLeft: '2rem',
    [MEDIA_QUERY.SM]: {
      width: '90%',
    },
  }),
}

export default LocationSelectNameView
